<template>
    <div class="new_grid topbar-content">
        <div class="new_grid__row">
            <div class="new_grid__col new_grid__col--auto-static order-2 order--sm--1">
                <slot name="header"></slot>
            </div>
            <div class="new_grid__col d-flex jc-end order-1 order--sm--1">
                <button class="topbar-content__close button sideBar__button button_with_icon button_type_icon" @click="hendleCloseClick">
                    <svg aria-hidden="true" width="20" height="20">
                        <use href="#icon-close"></use>
                    </svg>
                </button>
            </div>
        </div>
        <div class="new_grid__row">
            <slot name="body"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            hendleCloseClick() {
                this.close()
            },
            close() {
                this.$emit('hide',false)
            }
        }
    }
</script>

<style lang="scss">
    .topbar-content {
        .title { 
            color: #0A0A17;
            font-family: Inter;
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: 32px; /* 133.333% */
        }

        &__close { 
            flex: 0 0 auto!important;
            min-width: 1px!important;
        }
    }
    // .topbar-content, .topbar_vert-content {
    //     display: flex;
    //     flex-direction: column;
    //     @media screen and (min-width: 960px) {
    //         max-height: 500px;
    //     }
    //     //overflow: auto;
        
    //     &__top {
    //         display: flex;
    //         align-items: center;
    //         margin-bottom: 20px;
    //        
    //     }
    //     &__tools {
    //         margin-left: auto;
    //     }

    //     &__row {
    //         display: flex;
    //         align-items: flex-start;
    //         margin-left: -12px;
    //         margin-right: -12px;
    //         margin-bottom: 16px;
    //         &:last-child{
    //             margin-bottom: 0;
    //         }
    //     }
    //     &__col {
    //         flex: 1 1 auto;
    //         padding-left: 12px;
    //         padding-right: 12px;
    //     }
    // }

    // .topbar_vert-content { 
    //     &__row {
    //         @media screen and (min-width: 720px) and (max-width:960px) {
    //             flex-wrap: wrap;
    //         }
    //     }

    //     &__col {
    //         @media screen and (min-width: 720px) and (max-width:960px) {
    //             margin-bottom: 10px;
    //         }
    //     }
    // }
</style>